export default __webpack_public_path__ + "static/media/Ballroll_00086.cca44036.png";